// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RichText from '/react4xp/components/RichText'
import Image from '/react4xp/components/Image'

// svg
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface ListProductCategoriesProps {
    title?: {
        text: string
        size: 'small' | 'large'
    }
    categories: Array<{
        icon?: string
        title: string
        description: string
        cta?: {
            label: string
            href?: string
            isExternal?: boolean
            onClick?: () => void
        }
    }>
}

export default function ListProductCategories({
    title,
    categories
}: ListProductCategoriesProps) {

    function categoryClicked(item) {
        const cta = item.cta;

        if (!cta?.href) return;

        if (cta.isExternal) {
            window.open(cta.href, "_blank");
        } else {
            window.location.href = cta.href;
        }
    }  

    // without a part title the first category carries the page title (product category pages)
    const isPageTitle = !isNonWhitespaceString(title?.text)

    return (
        <Section
            textColor='text-dark'
            className='list-product-categories'
        >
            <div className='grid-container'>

                {isNonWhitespaceString(title?.text) && (
                    <div className='list-product-categories__header'>
                        {title.size === 'large' ? (
                            <h1 className='title title-lg'>
                                {title.text}
                            </h1>
                        ) : (
                            <h2 className='title subtitle'>
                                {title.text}
                            </h2>
                        )}
                    </div>
                )}

                {categories && categories.length > 0 && (
                    <div className='list-product-categories__items'>
                        {categories.map((item, i) => (
                            <div key={i} className={`${item?.cta?.href ? "product-category-as-list-item product-category": "product-category"}`} onClick={() => categoryClicked(item)}>

                                <div className={clsx('product-category__icon', !item.icon && 'product-category__icon--no-icon')}>
                                    {item.icon && (
                                        <Image
                                            src={item.icon} // 85x75
                                            alt={item.title}
                                        />
                                    )}
                                </div>

                                <div className='product-category__title'>
                                    {isNonWhitespaceString(item.title) && (
                                        isPageTitle && i === 0 ? (
                                            <h1 className='title-sm font-title'>
                                                {item.title}
                                            </h1>
                                        ) : (
                                            <p className='title-sm font-title'>
                                                {item.title}
                                            </p>
                                        )
                                    )}
                                </div>

                                <div className='product-category__content'>

                                    <div className='content-description'>
                                        {isNonWhitespaceString(item.description) && (
                                            <RichText content={item.description} />
                                        )}
                                    </div>

                                    {item.cta ? <div className='content-link'>
                                        {item.cta?.href ? (
                                            <a
                                                href={item.cta?.href}
                                                target={item.cta?.isExternal ? '_blank' : undefined}
                                            >
                                                <span>{item.cta?.label}</span>
                                                <UxArrowRight />
                                            </a>
                                        ) : (
                                            <button
                                                className=''
                                                onClick={item.cta?.onClick}
                                            >
                                                <span>{item.cta?.label}</span>
                                            </button>
                                        )}
                                    </div> : <></>}

                                </div>

                            </div>
                        ))}
                    </div>
                )}
                
            </div>
        </Section>
    )
}